import { MetadataType } from '@aibees/elephant/hooks';
import {
  departmentLabelFormatter,
  employeeByDepartmentRowDataFormatter,
} from '../components/filter-tags/utils';
import {
  FilterBadgeType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';
import { departmentsOptions } from './job-functions';

export default function employeeByDeptFilterConfig(): SearchFilterBase {
  return {
    id: 'Employee By Department',
    name: 'Employee By Department',
    icon: 'outline-group',
    index: 1,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    badge: FilterBadgeType.BETA,
    items: [
      {
        name: '',
        type: SearchFilterType.EMPLOYEE_BY_DEPARTMENT,
        index: 0,
        key: 'employee_by_department',
        field: 'employee_by_department',
        metadata: {
          color: 'primary',
        },
        utils: {
          tags: {
            rowDataFormatter: employeeByDepartmentRowDataFormatter,
            config: {
              showAsCard: true,
              tagsCardTitle: 'Department',
            },
          },
        },
        items: [
          {
            name: 'Department & Job functions',
            type: SearchFilterType.CUSTOM_SELECT,
            index: 0,
            key: 'employee_by_department_department',
            field: 'employee_by_department_department',
            metadata: {
              color: 'primary',
              placeholder: 'Search Dep. & Job functions',
              preset: 'employee_by_department',
              autocomplete: {
                recent: false,
                checkboxPosition: 'left',
                multiple: true,
                customOptions: true,
              },
              styles: {
                sx: {
                  background: 'transparent',
                },
              },
              metaDataApi: {
                key: MetadataType.COMPANY_DEPARTMENT,
                enabled: false,
              },
            },
            utils: {
              tags: {
                labelFormatter: departmentLabelFormatter,
              },
            },
            config: { labelKey: 'label', valueKey: 'value' },
            nested: true,
            treeOptions: departmentsOptions,
          },
          {
            name: '',
            type: SearchFilterType.NUMBER_RANGE,
            index: 0,
            key: 'employee_by_department_number',
            field: 'employee_by_department_number',
            metadata: {
              color: 'primary',
              styles: {
                sx: {
                  background: 'transparent',
                },
              },
            },
            open: true,
            nested: false,
          },
        ],
      },
    ],
  };
}
